import { Button, Result } from "antd"
import { Link } from "react-router-dom"

export const NotFound = () => {
    return (
        <Result
            status="404"
            title="404"
            subTitle="Essa página não existe."
            extra={<Link to='/'><Button type="primary">Voltar</Button></Link>}
        />
    )
}